import {
  find as _find,
  isObject as _isObject,
  map as _map,
  sortBy as _sortBy
} from 'lodash';

const reward = 15;

const state = {
  image: 0 // which photo to show while playing or reviewing
};

const actions = {
  startRound: ({ commit, rootGetters }) => {
    commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
      root: true
    });
    commit('SET_CURRENT_QUESTION', 0, { root: true });
    commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
  },
  startQuestion: ({ commit, dispatch, rootGetters }) => {
    return dispatch('startClockForActivePlayer', null, { root: true }).then(
      () => {
        commit('END_PLAYER_FIRST_TURN', rootGetters.activePlayer.id, {
          root: true
        });
        commit('SET_CURRENT_IMAGE', 0);
        commit('SHOW_ROUND_PLAYSCREEN', null, { root: true });
      }
    );
  },
  answerQuestion: (
    { commit, getters, dispatch, rootGetters },
    { keywordId, answer }
  ) => {
    const playerId = rootGetters.activePlayer.id;
    if (answer) {
      commit('REWARD_PLAYER', { playerId, score: reward }, { root: true });
      commit('MARK_KEYWORD_AS_FOUND', { keywordId, playerId }, { root: true });
      if (getters.allKeywordsAreFound) {
        dispatch('stopClock');
      }
    }
    if (getters.showImages && !rootGetters.reviewModeEnabled) {
      dispatch('nextImage');
    }
  },
  nextQuestion: ({ dispatch, commit, rootGetters }) => {
    if (rootGetters.nextPlayerToStartAQuestion) {
      commit('DISABLE_REVIEW_MODE', null, { root: true });
      commit('RESET_ALL_PLAYERS_TURNS', null, { root: true });
      commit('RESET_FOUND_KEYWORDS', null, { root: true });
      commit('NEXT_QUESTION', null, { root: true });
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerToStartAQuestion.id, {
        root: true
      });
      commit('SHOW_PLAYER_TURN_SCREEN', null, { root: true });
    } else {
      dispatch('nextRound', null, { root: true });
    }
  },
  prevImage: ({ state, commit }) => {
    if (state.image > 0) commit('PREV_IMAGE');
  },
  nextImage: ({ state, rootGetters, commit, dispatch, getters }) => {
    commit('NEXT_IMAGE');
    // are there any more images to show?
    if (
      state.image >= getters.activeQuestion.photos.length &&
      state.image <= getters.activeQuestion.photos.length
    ) {
      if (rootGetters.reviewModeEnabled) {
        dispatch('nextQuestion');
      } else {
        dispatch('stopClock');
      }
    }
  },
  stopClock: ({ dispatch, commit, getters, rootGetters }) => {
    commit('STOP_CLOCK', null, { root: true });
    dispatch('endActivePlayerTurn', null, { root: true });
    if (!getters.allKeywordsAreFound && rootGetters.nextPlayerByLowestScore) {
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
        root: true
      });
    } else {
      commit('SET_CURRENT_IMAGE', 0);
      dispatch('enableReviewMode', null, { root: true });
    }
  }
};

const mutations = {
  PREV_IMAGE: state => {
    state.image--;
  },
  NEXT_IMAGE: state => {
    state.image++;
  },
  SET_CURRENT_IMAGE: (state, imageId) => {
    state.image = imageId;
  }
};

const getters = {
  questions(state, getters, rootState) {
    return rootState.questionsPerRound[3].questions;
  },
  activeQuestion(state, getters, rootState) {
    return getters.questions[rootState.game.currentQuestion];
  },
  activeKeywords(state, getters, rootState, rootGetters) {
    return getters.activeQuestion.photos.map((photo, photoId) => {
      const foundKeyword = _find(
        rootState.game.foundKeywords,
        k => k.keywordId === photoId
      );
      return {
        id: photoId,
        name: photo.answer,
        found: _isObject(foundKeyword),
        foundBy: foundKeyword
          ? rootGetters.players[foundKeyword.playerId].name
          : false,
        score: reward
      };
    });
  },
  activeKeywordsSortedByFound(state, getters) {
    return _sortBy(getters.activeKeywords, ['found', 'id']);
  },
  activeImageUrls(state, getters) {
    return _map(getters.activeQuestion.photos, 'url');
  },
  activePhoto(state, getters) {
    return Object.assign(getters.activeQuestion.photos[state.image], {
      id: state.image
    });
  },
  allKeywordsAreFound(state, getters, rootState) {
    return (
      rootState.game.foundKeywords.length ===
      getters.activeQuestion.photos.length
    );
  },
  showImages(state, getters, rootState, rootGetters) {
    return (
      rootGetters.playersWithoutOpenTurns.length === 0 ||
      rootGetters.reviewModeEnabled
    );
  },
  preloadImgUrls(state, getters) {
    let urls = [];
    getters.questions.forEach(q => {
      urls = urls.concat(_map(q.photos, 'url'));
    });
    return urls;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
